import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  Logout = '[Auth] Logout',
  LoginSuccess = '[Auth] Login Success',
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export type AuthActionsUnion =
  | LoginSuccess
  | Logout;
